

import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Model1 from "./Sketch/Model1";
import Model2 from "./Sketch/Model2";
import Model3 from "./Sketch/Model3";

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Model1 />} />
                <Route path="/Model2" element={<Model2 />} />
                <Route path="/Model3" element={<Model3 />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;